
import * as angular from "angular";
import * as moment from "moment";

import { IMessageModel, IUnreadMessageModel } from "../models/IMessageModel";
import { ExpiryOptionsModel } from "../models/ExpiryOptionsModel";
import { TranslationService } from "@services/translation.service";

export class MessageService {

    static UnreadMessageCountUpdatedEvent = "UnreadMessageCountUpdatedEvent";

    static $inject = ["$rootScope", "$http", "translationService"];

    constructor(
        private $rootScope: angular.IRootScopeService,
        private $http: angular.IHttpService,
        private translationService: TranslationService) {
    }

    getLatestMessages(): angular.IPromise<IMessageModel[]> {
        return this.$http
            .get("/api/messages/latest")
            .then((result: angular.IHttpPromiseCallbackArg<IMessageModel[]>) => {
                return result.data;
            });
    }

    getMessageUnreadCounts() {
        return this.$http
            .get("/api/messages/unread")
            .then((result: angular.IHttpPromiseCallbackArg<IUnreadMessageModel[]>) => {
                var unreadMessageModels = result.data;

                var numUnreadMessages = 0;
                angular.forEach(unreadMessageModels, unreadMessage => {
                    numUnreadMessages += unreadMessage.UnreadMessages;
                });

                this.$rootScope.$broadcast(MessageService.UnreadMessageCountUpdatedEvent, numUnreadMessages);

                return unreadMessageModels;
            });
    }

    sendMessage(message: IMessageModel): angular.IPromise<any> {
        return this.$http
            .post("/api/messages/", message)
            .then((result: angular.IHttpPromiseCallbackArg<any>) => {
                return result.data;
            });
    }

    getMessagesForVehicle(vehicleId: number, page: number, pageSize: number, dateFrom?: moment.Moment, dateTo?: moment.Moment): angular.IPromise<IMessageModel[]> {

        if (!vehicleId) {
            console.error("No vehicle supplied in getMessagesForVehicle()", vehicleId);
        }

        var params: any = {
            page: page,
            pageSize: pageSize,
            dateFrom: dateFrom ? dateFrom.utc().format() : null,
            dateTo: dateTo ? dateTo.utc().format() : null
        };

        return this
            .$http({
                method: "GET",
                url: `/api/messages/vehicle/${vehicleId}`,
                params: params
            })
            .then((result: angular.IHttpPromiseCallbackArg<IMessageModel[]>) => {
                return result.data;
            });
    }

    setConversationMessagesToRead(vehicleId: number): angular.IPromise<any> {
        return this.$http({
            method: "POST",
            url: `/api/messages/vehicle/${vehicleId}/read`
        });
    }

    setMessageToRead(messageId: number): angular.IPromise<any> {
        return this.$http({
            method: "POST",
            url: `/api/messages/${messageId}/read`
        });
    }

    createMessageModel(messageBody: string, expiryCode: number): IMessageModel {

        var newMessage: IMessageModel = {
            VehicleId: -1,
            GroupId: -1,
            Body: messageBody,
            Subject: "",
            ExpiryCode: expiryCode,
            MsgCode: -1, // Used by UI to indicate "sending"
            TimestampQueued: moment().toISOString(),
            Originator: 0
        };

        return newMessage;
    }

    getExpiryOptions(): ExpiryOptionsModel[] {
        const expiryOptions: ExpiryOptionsModel[] = [];

        expiryOptions.push(new ExpiryOptionsModel(2, `1 ${this.translationService.t("Common.Hour")}`));
        expiryOptions.push(new ExpiryOptionsModel(3, `2 ${this.translationService.t("Common.Hours")}`));
        expiryOptions.push(new ExpiryOptionsModel(4, `4 ${this.translationService.t("Common.Hours")}`));
        expiryOptions.push(new ExpiryOptionsModel(5, `8 ${this.translationService.t("Common.Hours")}`));
        expiryOptions.push(new ExpiryOptionsModel(6, `12 ${this.translationService.t("Common.Hours")}`));
        expiryOptions.push(new ExpiryOptionsModel(7, `24 ${this.translationService.t("Common.Hours")}`));

        return expiryOptions;
    }
}
